var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pricing-data",class:{ 'pricing-data--not-last': _vm.isNotLast,'pricing-data--hidden': _vm.ishidden }},[_c('i',{staticClass:"pricing-data__icon"}),_c('p',{staticClass:"pricing-data__text",domProps:{"innerHTML":_vm._s(_vm.pricingDataText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }